import { graphQLClient } from '@api/client';
import { useCreatePatientMutation } from '@api/GoodocAPI';
import { useTreatmentInformationContext } from '@context/TreatmentInformation';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import {
  RRN_COMPLETE_BUTTON,
  RRN_INPUT
} from '@pages/PatientSetting/views/PatientResidentRegistrationNumberInput/focuskey';
import constate from 'constate';
import { ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const usePatientResidentRegistrationNumber = () => {
  const { setFocus } = useFocusable();

  const focusRRNInput = () => {
    setFocus(RRN_INPUT);
  };
  const focusCompleteButton = () => {
    setFocus(RRN_COMPLETE_BUTTON);
  };

  const navigate = useNavigate();

  const { name, registrationNumber, setRegistrationNumber } =
    useTreatmentInformationContext();
  const { mutateAsync: createPatient } = useCreatePatientMutation(graphQLClient);

  const addHyphen = (registrationNumber: string) => {
    return (
      registrationNumber.slice(0, 6) +
      '-' +
      registrationNumber.slice(6, registrationNumber.length)
    );
  };

  const removeHyphen = (registrationNumber: string) => {
    return registrationNumber.replace('-', '');
  };

  const filterNumberAndHyphen = (value: string) => {
    return value.replace(/[^\d.-]/g, '');
  };

  const refineRRN = (e: ChangeEvent<HTMLInputElement>) => {
    let registrationNumber = filterNumberAndHyphen(e.target.value);

    if (registrationNumber.length > 14) {
      return;
    }

    if (registrationNumber.length <= 7 && registrationNumber.includes('-')) {
      registrationNumber = removeHyphen(registrationNumber);
    } else if (registrationNumber.length > 6 && !registrationNumber.includes('-')) {
      registrationNumber = addHyphen(registrationNumber);
    }

    setRegistrationNumber(registrationNumber);
  };

  const goBack = () => {
    navigate(-1);
  };

  const createPatientAction = async () => {
    if (registrationNumber.length < 14) return;
    try {
      await createPatient({ name, residentRegistrationNumber: registrationNumber });
      navigate(-2);
    } catch (e) {}
  };

  return {
    goBack,
    registrationNumber,
    refineRRN,
    createPatientAction,
    focusCompleteButton,
    focusRRNInput
  };
};

export const [
  PatientResidentRegistrationNumberProvider,
  usePatientResidentRegistrationNumberContext
] = constate(usePatientResidentRegistrationNumber);
